export default {
  container: {
    padding: 10,
  },
  main: {
    margin: 5,
    flex: 1,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  chip: {
    margin: 10,
    // padding: 10,
  },
  profile: {
    margin: 5,
    padding: 5,
  },
  roleHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  roleLabel: {
    flex: 1,
  },
  tagsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
  },
  tagsLabel: {
    flex: 1,
  },
  iconCol: {
    width: 40,
  },
  actionCol: {
    width: 90,
  },
  icon: {
    height: 30,
    width: 30,
  },
  // contact: {
  //   display: 'flex',
  //   flex: 1,
  //   flexDirection: 'row',
  //   padding: 10,
  //   margin: 3,
  // },

  nameCol: {
    // width: 100,
  },
  assignedToCol: {
    width: 100,
  },
  completedByCol: {
    width: 100,
  },
  completedAtCol: {
    width: 70,
  },
  statusCol: {
    width: 70,
  },

  paper: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/styles.js